<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex>
        <Card>
          <v-layout row wrap>
            <v-card-title>{{ $t("CONTROL") }}</v-card-title>
            <v-spacer></v-spacer>
            <v-flex v-if="getSelectedPlantId !== 159">
              <v-btn v-if="selectedDevices.length === 0" disabled>{{
                $t("CHANGE INVERTER STATE")
              }}</v-btn>
              <v-btn v-else @click="submitAllDialog = true" color="success">{{
                $t("CHANGE SELECTED INVERTER STATE")
              }}</v-btn>
            </v-flex>
          </v-layout>
          <v-dialog v-model="dialog_confirmation" persistent max-width="40%">
            <Card>
              <v-card-title class="headline">{{
                $t("Are you sure to change")
              }}</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="error"
                  flat
                  @click="dialog_confirmation = false"
                  >{{ $t("NO") }}</v-btn
                >
                <v-btn
                  color="success"
                  v-on:click="
                    changeState(
                      apic_ID,
                      d_ID,
                      d_Type,
                      d_Name,
                      apiDeviceStatus[`${d_Type}-${d_ID}`] === '0' ? '1' : '0'
                    );
                    dialog_confirmation = false;
                  "
                  flat
                  >{{ $t("Yes") }}</v-btn
                >
              </v-card-actions>
            </Card>
          </v-dialog>
          <v-dialog v-model="dialog_mqtterror" max-width="40%">
            <Card>
              <v-card-title class="headline">
                <center>{{ $t("Sorry Connection Lost with Device") }}</center>
              </v-card-title>
            </Card>
          </v-dialog>
          <v-dialog v-model="updated" max-width="30%">
            <Card>
              <v-card-title class="headline">
                <center>{{ $t("Updated Successfully") }}</center>
              </v-card-title>
            </Card>
          </v-dialog>
          <v-dialog v-model="error" max-width="30%">
            <Card>
              <v-card-title class="headline">
                <center>{{ $t("Failed! Retry again") }}</center>
              </v-card-title>
            </Card>
          </v-dialog>
          <v-dialog v-model="dialog_inCorrectPassword" max-width="40%">
            <Card>
              <v-card-title class="headline">
                <center>
                  {{ $t("Username or password entered is incorrect") }}
                </center>
              </v-card-title>
            </Card>
          </v-dialog>
          <v-dialog v-model="dialog_password" max-width="30%">
            <Card class="pa-3">
              <v-card-title class="title pa-2 justify-center"
                >{{ $t("Enter the Password") }}
              </v-card-title>
              <v-divider></v-divider>
              <v-form class="pa-2">
                {{ $t("Email") }}
                <v-text-field
                  class="pa-0"
                  v-model="userId"
                  autocomplete="email"
                ></v-text-field>
                {{ $t("Password") }}
                <v-text-field
                  class="pa-0"
                  type="password"
                  v-model="password"
                  autocomplete="new-password"
                  required
                >
                </v-text-field>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="error" @click="dialog_password = false">{{
                    $t("Reject")
                  }}</v-btn>
                  <v-btn
                    class="success"
                    v-on:click="
                      checkPassword(userId, password);
                      dialog_password = false;
                    "
                  >
                    {{ $t("Submit") }}
                  </v-btn>
                </v-card-actions>
              </v-form>
            </Card>
          </v-dialog>
          <v-dialog v-model="decimal" width="500">
            <Card>
              <v-card-title class="headline">
                <center>{{ $t("Please enter an interger") }}</center>
              </v-card-title>
            </Card>
          </v-dialog>
          <v-dialog v-model="activeDialog" width="500">
            <Card>
              <v-card-title class="headline">
                <center>
                  {{ $t("Please Enter Active Power Value Between") }} ({{
                    power["min_active_power"]
                  }}) - ({{ power["max_active_power"] }})
                </center>
              </v-card-title>
            </Card>
          </v-dialog>
          <v-dialog v-model="reactiveDialog" width="500">
            <Card>
              <v-card-title class="headline">
                <center>
                  {{ $t("Please Enter Reactive Power Value Between") }} ({{
                    power["min_reactive_power"]
                  }}) - ({{ power["max_reactive_power"] }})
                </center>
              </v-card-title>
            </Card>
          </v-dialog>
          <v-dialog v-model="powerFactorDialog" width="500">
            <Card>
              <v-card-title class="headline">
                <center>
                  {{ $t("Please Enter Power Factor Value Between") }} ({{
                    power["min_power_factor"]
                  }}) - ({{ power["max_power_factor"] }})
                </center>
              </v-card-title>
            </Card>
          </v-dialog>
          <v-dialog v-model="submitAllDialog" width="500">
            <Card>
              <v-card-title class="headline">
                <center>{{ $t("Are You Sure To Change") }}</center>
              </v-card-title>
              <v-card-actions>
                <v-btn @click="submitAllDialog = false">{{ $t("NO") }}</v-btn>
                <v-btn
                  @click="
                    submitAllDialog = false;
                    submitAll();
                  "
                  >{{ $t("YES") }}</v-btn
                >
              </v-card-actions>
            </Card>
          </v-dialog>
        </Card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="confirmationDialog"
      persistent
      max-width="40%"
      class="dialog"
    >
      <Card>
        <v-card-title class="subheading"
          >{{ $t("Are you sure you want to change the state") }}?</v-card-title
        >
        <v-card-actions class="justify-end">
          <v-btn color="error" @click="confirmationDialog = false">{{
            $t("NO")
          }}</v-btn>
          <v-btn
            color="success"
            v-on:click="
              changeState(apic_ID, d_ID, d_Type, d_Name, d_State);
              confirmationDialog = false;
            "
          >
            {{ $t("YES") }}</v-btn
          >
        </v-card-actions>
      </Card>
    </v-dialog>
    <v-layout row wrap text-xs-center>
      <v-flex
        xs12
        sm6
        md4
        lg3
        xl3
        v-for="item in vcbList"
        :key="item.device_id"
      >
        <Card>
          <v-flex :key="componentKey">
            <span
              :style="{
                color: vcbConnected[
                  `${item.device_type}-${item.device_id}-${item.apic_id}`
                ]
                  ? 'success'
                  : 'error',
              }"
              >{{
                vcbConnected[
                  `${item.device_type}-${item.device_id}-${item.apic_id}`
                ]
                  ? $t("Connected")
                  : $t("Connection Lost")
              }}</span
            >
          </v-flex>
          <v-btn
            :disabled="
              !vcbConnected[
                `${item.device_type}-${item.device_id}-${item.apic_id}`
              ]
            "
            :color="
              vcbStatus[`${item.device_id}-${item.device_name}`] &&
              vcbStatus[`${item.device_id}-${item.device_name}`] === 1
                ? 'success'
                : 'error'
            "
            @click="clickVCB(item)"
            >{{ item.device_name }}</v-btn
          >
          <v-flex>
            <span>
              {{ item.device_name }} {{ $t("is currently") }}
              {{
                vcbStatus[`${item.device_id}-${item.device_name}`] &&
                vcbStatus[`${item.device_id}-${item.device_name}`] === 1
                  ? $t("ON")
                  : $t("OFF")
              }}
            </span>
          </v-flex>
        </Card>
      </v-flex>
    </v-layout>
    <v-layout row wrap text-xs-center>
      <v-flex xs12 sm6 md4 lg4 xl3 v-for="n in deviceList" :key="n.device_id">
        <Card>
          <v-flex>
            <span
              :style="{
                color: connected[`${n.device_id}-${n.apic_id}`]
                  ? 'success'
                  : 'error',
              }"
              >{{
                connected[`${n.device_id}-${n.apic_id}`]
                  ? $t("Connected")
                  : $t("Connection Lost")
              }}</span
            >
            <v-checkbox
              class="font-weight-black title"
              v-model="selectCheckBox[`${n.device_id}-${n.apic_id}`]"
              :disabled="!connected[`${n.device_id}-${n.apic_id}`]"
              @click.native="checkBox(n)"
              :label="$t('Change inverter state')"
            >
            </v-checkbox>
          </v-flex>
          <v-btn
            :disabled="!connected[`${n.device_id}-${n.apic_id}`]"
            :color="
              apiDeviceStatus[n.id] && apiDeviceStatus[n.id] === '1'
                ? 'success'
                : 'error'
            "
            :key="compKey"
            @click.stop="
              compKey++;
              clickSpecificDevice(n);
            "
            >{{ n.device_name }}</v-btn
          >
          {{ $t("Current status of") }}
          {{ n.device_name }} {{ $t("is") }}
          {{
            apiDeviceStatus[n.id]
              ? apiDeviceStatus[n.id] === "0"
                ? $t("OFF")
                : $t("ON")
              : $t("OFF")
          }}
          <br />
          <Card>
            <v-layout v-if="n.active_power" pa-2>
              <v-flex
                sm2
                md2
                lg3
                xl3
                class="font-weight-bold text-v-align primary"
                pa-2
              >
                {{ $t(n.active_power.label) }}
              </v-flex>
              <v-flex sm6 md4 lg4 xl3>
                <v-text-field
                  v-model="activePower[`${n.device_id}-${n.apic_id}`]"
                  outline
                ></v-text-field>
              </v-flex>
              <v-btn
                v-if="!n.active_power.scheduling"
                :disabled="!connected[`${n.device_id}-${n.apic_id}`]"
                color="success"
                @click="submitActivePower(n)"
                >{{ $t("SUBMIT") }}</v-btn
              >
            </v-layout>

            <v-layout v-if="n.active_power.scheduling" pa-1>
              <div>
                <div class="d-flex flex-column-reverse">
                  <v-flex
                    sm6
                    md4
                    lg5
                    xl3
                    class="font-weight-bold text-v-align"
                    pa-2
                    >{{ $t("Time") }}</v-flex
                  >
                  <v-flex sm6 md4 lg4 xl3 pa-2>
                    <v-text-field
                      outline
                      shaped
                      @change="scheduleTime = $event"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm2 md2 lg3 xl2 pa-2>
                    <v-select
                      v-model="select"
                      :label="$t('select')"
                      :items="list"
                      item-text="text"
                      item-value="value"
                      solo
                      return-object
                    ></v-select>
                  </v-flex>
                  <v-btn
                    :disabled="!connected[`${n.device_id}-${n.apic_id}`]"
                    color="success"
                    @click="
                      submitActivePower(n);
                      isScduledTime = true;
                    "
                    >{{ $t("SUBMIT") }}</v-btn
                  >
                </div>
              </div>
            </v-layout>
            <v-layout v-if="n.reactive_power" pa-2>
              <v-flex
                sm2
                md2
                lg3
                xl3
                class="font-weight-bold text-v-align"
                pa-2
              >
                {{ $t(n.reactive_power.label) }}
              </v-flex>
              <v-flex sm6 md4 lg4 xl3>
                <v-text-field
                  v-model="reactivePower[`${n.device_id}-${n.apic_id}`]"
                  outline
                  required
                ></v-text-field>
              </v-flex>
              <v-btn
                :disabled="!connected[`${n.device_id}-${n.apic_id}`]"
                color="success"
                @click="submitReactivePower(n)"
              >
                {{ $t("SUBMIT") }}</v-btn
              >
            </v-layout>
            <v-layout v-if="n.power_factor" pa-2>
              <v-flex
                sm2
                md2
                lg3
                xl3
                class="font-weight-bold text-v-align primary"
                pa-2
              >
                {{ $t(n.power_factor.label) }}
              </v-flex>
              <v-flex sm6 md4 lg4 xl3>
                <v-text-field
                  type="number"
                  v-model="powerFactor[`${n.device_id}-${n.apic_id}`]"
                  outline
                  required
                >
                </v-text-field>
              </v-flex>
              <v-btn
                :disabled="!connected[`${n.device_id}-${n.apic_id}`]"
                color="success"
                @click="submitPowerFactor(n)"
              >
                {{ $t("SUBMIT") }}
              </v-btn>
            </v-layout>
          </Card>
        </Card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Controlling from "@/services/Controlling";
const mqtt = require("mqtt");

export default {
  data() {
    return {
      select: { text: "Sec", value: "s" },
      list: [
        {
          text: "Sec",
          value: "s",
        },
        {
          text: "min",
          value: "m",
        },
      ],
      sTime: 0,
      scheduleTime: 0,
      isScduledTime: false,
      powerFactorDialog: false,
      power: {},
      editDialog: false,
      vcbConnected: {},
      confirmationDialog: false,
      vcbList: [],
      inaugurationDialog: false,
      vcbStatus: {},
      componentKey: 0,
      isVcbCntrl: false,
      decimal: false,
      submitAllDialog: false,
      selectCheckBox: {},
      selectedDevices: [],
      deviceList: [],
      activeDialog: false,
      reactiveDialog: false,
      invStatus: false,
      updated: false,
      error: false,
      activePower: {},
      reactivePower: {},
      powerFactor: {},
      isActivePower: false,
      isReactivePower: false,
      isPowerFactor: false,
      apiData: [],
      d_Name: "",
      d_Type: "",
      d_ID: "",
      d_State: {},
      apic_ID: "",
      d_Interface: "",
      client: null,
      device_id: null,
      device_name: null,
      device_type: null,
      apiDeviceStatus: {},
      topicValue: "",
      msg: null,
      compKey: 0,
      dialog_confirmation: false,
      dialog_mqtterror: false,
      dialog_password: false,
      connected: {},
      dialog_inCorrectPassword: false,
      confirmation: null,
      mqttStatus: {},
      selectedId: null,
      userId: "",
      password: "",
      email: "",
    };
  },

  async created() {
    this.userId = this.getUserInfo("email");
    this.client = mqtt.connect(process.env.VUE_APP_MQTT_URL, {
      username: "test",
      password: "test",
    });

    this.client.on("connect", () => {
      this.client.subscribe(`control_feedback/${this.getSelectedPlantId}/#`);
      this.client.subscribe("/state/change/#");
      this.client.subscribe(`epicConnection/${this.getSelectedPlantId}`);
    });

    this.client.on("message", async (topic, message) => {
      console.log("TOPIC", topic, " MSG", JSON.parse(message.toString()));
      if (topic == `epicConnection/${this.getSelectedPlantId}`) {
        this.getData();
        this.getVCBData();
      } else if (topic.startsWith("/state/change")) {
        let msg = JSON.parse(message.toString());

        let [blockId, roomId, deviceId] = msg.device_id.split("-");
        let deviceTyp = msg.device_type === "breaker" ? "vcb" : msg.device_type;
        let grouped = _.groupBy(this.vcbList, "device_id");

        if (grouped[msg.device_id] && grouped[msg.device_id][0]) {
          let deviceName = grouped[msg.device_id][0]["device_name"];
          let param = {
            plantId: msg.plant_id,
            blockId,
            roomId,
            sensor_time: msg.timestamp,
            deviceId,
            deviceTyp,
            device_name: deviceName,
            status: msg.state,
            updatedBy: "automatic",
          };
          this.insertDevicestatus(param);
          await this.getVcbStatus();
        } else
          console.log(
            `DEVICE NAME FOR ${msg.device_id} NOT FOUND.COULD NOT INSERT`
          );
      } else {
        let m = JSON.parse(message.toString());
        let [, , , deviceTyp] = topic.split("/");
        let { device_name } = m;
        let [, plantId, , deviceType, blockId, roomId, deviceId, timestamp] =
          topic.split("/");

        let parm = {
          plantId,
          blockId,
          roomId,
          sensor_time: m.timestamp,
          deviceId,
          deviceTyp,
          device_name,
          updatedBy: this.email,
        };
        if (m.active_power && m.active_power[0] == "true") this.updated = true;
        else if (m.reactive_power && m.reactive_power[0] == "true")
          this.updated = true;
        else if (m.power_factor && m.power_factor[0] == "true")
          this.updated = true;
        else if (m.device_type === "vcb" && m.status && m.status[0] == "true") {
          parm["status"] =
            this.vcbStatus[`${m.device_id}-${m.device_name}`] === 1 ? 0 : 1;
          this.insertDevicestatus(parm);
          await this.getVcbStatus();
          this.updated = true;
        } else if (
          m.device_type === "inverter" &&
          m.status &&
          m.status[0] == "true"
        ) {
          parm["status"] =
            this.apiDeviceStatus[`${m.device_type}-${m.device_id}`] === "1"
              ? 0
              : 1;
          this.insertDevicestatus(parm);
          await this.getDevicestatus();
          this.updated = true;
        } else this.error = true;
      }
    });

    this.client.on("error", function (error) {
      this.mqttStatus = {};
    });

    this.client.on("offline", function () {
      this.mqttStatus = {};
    });

    this.client.on("reconnect", function () {
      this.mqttStatus = {};
    });
    await this.getData();
    await this.getVCBData();
    await this.getVcbStatus();
    this.getDevicestatus();
  },

  computed: {
    ...mapGetters(["getUserInfo", "getSelectedPlantId"]),
  },

  methods: {
    ...mapActions([
      "validateUserAction"
    ]),
    async getData() {
      let response = await Controlling.controllableDeviceList(
        this.getSelectedPlantId
      );
      this.deviceList = [];
      if (response.status === 200) {
        this.apiData = response.data.message;
        this.apiData.forEach((i) => {
          let dList = {};
          dList["apic_id"] = i["apic_id"];
          dList["device_id"] = i["device_id"];
          dList["device_type"] = i["device_type"];
          dList["device_name"] = i["device_name"];
          dList.id = `${i.device_type}-${i.device_id}`;
          dList["active_power"] = i["params"].active_power;
          dList["reactive_power"] = i["params"].reactive_power;
          dList["power_factor"] = i["params"].power_factor;
          this.deviceList.push(dList);

          this.selectCheckBox[`${i.device_id}-${i.apic_id}`] = false;
          this.mqttStatus[`${i.device_id}`] = i["apic_connected"] === 1;
          this.connected[`${i.device_id}-${i.apic_id}`] =
            i["apic_connected"] === 1;

          this.activePower[`${i.device_id}-${i.apic_id}`] = null;
          this.reactivePower[`${i.device_id}-${i.apic_id}`] = null;
          this.powerFactor[`${i.device_id}-${i.apic_id}`] = null;
        });
      } else {
        console.log("No api data");
      }
    },

    async getVCBData() {
      const response = await Controlling.getVcbList(this.getSelectedPlantId);
      this.vcbList = response.data.message;
      this.vcbList.forEach((el) => {
        this.vcbConnected[`${el.device_type}-${el.device_id}-${el.apic_id}`] =
          el.apic_connected;
      });
    },

    async getVcbStatus() {
      const response = await Controlling.getVcbStatus(this.getSelectedPlantId);
      let list = response.data.message;
      console.log("VCB LIST", list);
      list.forEach((el) => {
        this.vcbStatus[`${el.device_id}-${el.device_name}`] = el.device_status;
        this.componentKey++;
      });
    },

    async getDevicestatus() {
      let response = await Controlling.controllableDeviceDetails(
        this.getSelectedPlantId
      );
      if (response.status === 200) {
        response.data.message.forEach((item) => {
          this.apiDeviceStatus[`${item.device_type}-${item.device_id}`] =
            item.device_status === 0 ? "0" : "1";
          this.compKey++;
        });
      } else {
        console.log("Error while fetching");
      }
    },

    async insertDevicestatus(param) {
      console.log("Insert State Change", param);
      let response = await Controlling.insertDeviceStateChange(param);
      this.getDevicestatus();
      this.getVcbStatus();
    },

    checkBox(n) {
      if (this.selectCheckBox[`${n.device_id}-${n.apic_id}`]) {
        let nList = {};
        nList[`apic_id`] = n.apic_id;
        nList[`d_id`] = n.device_id;
        nList[`d_name`] = n.device_name;
        nList[`d_type`] = n.device_type;
        nList[`id`] = n.id;
        this.selectedDevices.push(nList);
        this.selectCheckBox[`${n.device_id}-${n.apic_id}`] = true;
      } else {
        this.selectCheckBox[`${n.device_id}-${n.apic_id}`] = false;
        for (let i = 0; i < this.selectedDevices.length; i += 1) {
          this.selectedDevices.splice(this.selectedDevices[i], 1);
        }
      }
    },

    clickSpecificDevice: function (n) {
      this.invStatus = true;
      this.d_Name = n.device_name;
      this.apic_ID = n.apic_id;
      this.d_ID = n.device_id;
      this.d_Type = n.device_type;
      this.d_State = this.apiDeviceStatus[n.id];
      this.d_Interface = n.device_interface;
      this.selectedId = n.id;
      if (
        this.mqttStatus[this.d_ID] &&
        this.connected[`${n.device_id}-${n.apic_id}`]
      )
        this.dialog_password = true;
      else this.dialog_mqtterror = true;
    },

    clickVCB(n) {
      this.isVcbCntrl = true;
      this.d_Name = n.device_name;
      this.apic_ID = n.apic_id;
      this.d_ID = n.device_id;
      this.d_Type = n.device_type;
      this.d_State =
        this.vcbStatus[`${n.device_id}-${n.device_name}`] === 1 ? "0" : "1";
      console.log("STATE", this.d_State);
      this.d_Interface = n.device_interface;
      if (this.vcbConnected[`${n.device_type}-${n.device_id}-${n.apic_id}`])
        this.dialog_password = true;
      else this.dialog_mqtterror = true;
    },

    submitActivePower(n) {
      this.power["max_active_power"] = parseInt(
        n.active_power.range.max_active_power
      );
      this.power["min_active_power"] = parseInt(
        n.active_power.range.min_active_power
      );
      let actPow = parseInt(this.activePower[`${n.device_id}-${n.apic_id}`]);
      if (this.activePower[`${n.device_id}-${n.apic_id}`] % 1 === 0) {
        if (
          actPow >= this.power["min_active_power"] &&
          actPow <= this.power["max_active_power"]
        ) {
          this.d_Name = n.device_name;
          this.apic_ID = n.apic_id;
          this.d_ID = n.device_id;
          this.d_Type = n.device_type;
          this.d_Interface = n.device_interface;
          this.selectedId = n.id;
          this.isActivePower = true;
          if (
            this.mqttStatus[this.d_ID] &&
            this.connected[`${n.device_id}-${n.apic_id}`]
          )
            this.dialog_password = true;
          else this.dialog_mqtterror = true;
        } else {
          this.activeDialog = true;
        }
      } else {
        this.decimal = true;
      }
    },

    submitReactivePower(n) {
      this.power["max_reactive_power"] = parseInt(
        n.reactive_power.range.max_reactive_power
      );
      this.power["min_reactive_power"] = parseInt(
        n.reactive_power.range.min_reactive_power
      );
      let reactPow = parseInt(
        this.reactivePower[`${n.device_id}-${n.apic_id}`]
      );
      if (this.reactivePower[`${n.device_id}-${n.apic_id}`] % 1 === 0) {
        if (
          reactPow >= this.power["min_reactive_power"] &&
          reactPow <= this.power["max_reactive_power"]
        ) {
          this.d_Name = n.device_name;
          this.apic_ID = n.apic_id;
          this.d_ID = n.device_id;
          this.d_Type = n.device_type;
          this.d_Interface = n.device_interface;
          this.selectedId = n.id;
          this.isReactivePower = true;
          if (
            this.mqttStatus[this.d_ID] &&
            this.connected[`${n.device_id}-${n.apic_id}`]
          )
            this.dialog_password = true;
          else this.dialog_mqtterror = true;
        } else {
          this.reactiveDialog = true;
        }
      } else {
        this.decimal = true;
      }
    },

    submitPowerFactor(n) {
      this.power["max_power_factor"] = parseFloat(
        n.power_factor.range.max_power_factor
      );
      this.power["min_power_factor"] = parseFloat(
        n.power_factor.range.min_power_factor
      );
      let powFact = parseFloat(this.powerFactor[`${n.device_id}-${n.apic_id}`]);
      if (
        powFact <= this.power["max_power_factor"] &&
        powFact >= this.power["min_power_factor"]
      ) {
        this.d_Name = n.device_name;
        this.apic_ID = n.apic_id;
        this.d_ID = n.device_id;
        this.d_Type = n.device_type;
        this.d_Interface = n.device_interface;
        this.selectedId = n.id;
        this.isPowerFactor = true;
        if (
          this.mqttStatus[this.d_ID] &&
          this.connected[`${n.device_id}-${n.apic_id}`]
        )
          this.dialog_password = true;
        else this.dialog_mqtterror = true;
      } else {
        this.powerFactorDialog = true;
      }
    },

    submitAll() {
      for (let i = 0; i < this.selectedDevices.length; i += 1) {
        let el = this.selectedDevices[i];
        this.invStatus = true;
        this.selectCheckBox[`${el.d_id}-${el.apic_id}`] = false;
        this.changeState(
          el.apic_id,
          el.d_id,
          el.d_type,
          el.d_name,
          this.apiDeviceStatus[el.id] === "0" ? 1 : 0
        );
      }
      this.selectedDevices = [];
    },

    checkPassword: async function (email, password) {
      this.userId = email;
      this.password = password;

      if (password.length <= 1) {
        this.dialog_inCorrectPassword = true;
        return;
      }

      try {
        await this.validateUserAction({
          email,
          password,
        })
        if (this.mqttStatus[this.d_ID]) {
          this.dialog_confirmation = true;
        } else if (this.vcbConnected[`${this.d_Type}-${this.d_ID}-${this.apic_ID}`]) {
          this.confirmationDialog = true;
        } else {
          this.dialog_mqtterror = true;
        }
      } catch (err) {
        console.log(err);
      }
    },
    changeState: function (apic_id, d_id, d_type, d_name, state) {
      console.log("INSIDE CHANGE", state);
      let blockPath = d_id.split("-").join("/");
      this.topicValue = `control/${this.getSelectedPlantId}/${apic_id}/${d_type}/${blockPath}`;
      if (this.isActivePower) {
        this.msg = {
          plant_id: this.getSelectedPlantId,
          device_id: d_id,
          device_name: d_name,
          device_type: d_type,
          active_power: this.activePower[`${d_id}-${apic_id}`],
        };
        this.isActivePower = false;
      }
      if (this.isScduledTime) {
        this.msg = {
          plant_id: this.getSelectedPlantId,
          device_id: d_id,
          device_name: d_name,
          device_type: d_type,
          active_power: this.activePower[`${d_id}-${apic_id}`],
          time: this.sTime,
        };
        this.isScduledTime = false;
      }
      if (this.isReactivePower) {
        this.msg = {
          plant_id: this.getSelectedPlantId,
          device_id: d_id,
          device_name: d_name,
          device_type: d_type,
          reactive_power: this.reactivePower[`${d_id}-${apic_id}`],
        };
        this.isReactivePower = false;
      }
      if (this.invStatus) {
        this.msg = {
          plant_id: this.getSelectedPlantId,
          device_id: d_id,
          device_name: d_name,
          device_type: d_type,
          status: state,
        };
        this.invStatus = false;
      }
      if (this.isVcbCntrl) {
        this.msg = {
          plant_id: this.getSelectedPlantId,
          device_id: d_id,
          device_name: d_name,
          device_type: d_type,
          status: this.d_State,
        };
        this.isVcbCntrl = false;
      }
      if (this.isPowerFactor) {
        this.msg = {
          plant_id: this.getSelectedPlantId,
          device_id: d_id,
          device_name: d_name,
          device_type: d_type,
          power_factor: this.powerFactor[`${d_id}-${apic_id}`],
        };
        this.isPowerFactor = false;
      }
      this.client.publish(this.topicValue, JSON.stringify(this.msg));
      console.log(
        "PUBLISHED topic",
        this.topicValue,
        "msg",
        JSON.stringify(this.msg)
      );
      this.getDevicestatus();
      this.getVcbStatus();
    },
  },

  watch: {
    select: function (type) {
      if (type.value == "m") this.sTime = this.scheduleTime * 60;
      else if (type.value == "h") this.sTime = this.scheduleTime * 3600;
      else this.sTime = this.scheduleTime;
    },
    scheduleTime: function (type) {
      if (type.value == "m") this.sTime = this.scheduleTime * 60;
      else if (type.value == "h") this.sTime = this.scheduleTime * 3600;
      else this.sTime = this.scheduleTime;
    },
    async getSelectedPlantId() {
      this.client = mqtt.connect(process.env.VUE_APP_MQTT_URL, {
        username: "test",
        password: "test",
      });

      this.client.on("connect", () => {
        this.client.subscribe(`control_feedback/${this.getSelectedPlantId}/#`);
        this.client.subscribe("/state/change/#");
        this.client.subscribe(`epicConnection/${this.getSelectedPlantId}`);
      });

      this.client.on("message", async (topic, message) => {
        console.log("TOPIC", topic, " MSG", JSON.parse(message.toString()));
        if (topic == `epicConnection/${this.getSelectedPlantId}`) {
          this.getData();
          this.getVCBData();
        } else if (topic.startsWith("/state/change")) {
          let msg = JSON.parse(message.toString());

          let [blockId, roomId, deviceId] = msg.device_id.split("-");
          let deviceTyp = msg.device_type === "breaker" ? "vcb" : msg.device_type;
          let grouped = _.groupBy(this.vcbList, "device_id");

          if (grouped[msg.device_id] && grouped[msg.device_id][0]) {
            let deviceName = grouped[msg.device_id][0]["device_name"];
            let param = {
              plantId: msg.plant_id,
              blockId,
              roomId,
              sensor_time: msg.timestamp,
              deviceId,
              deviceTyp,
              device_name: deviceName,
              status: msg.state,
              updatedBy: "automatic",
            };
            this.insertDevicestatus(param);
            await this.getVcbStatus();
          } else
            console.log(
              `DEVICE NAME FOR ${msg.device_id} NOT FOUND.COULD NOT INSERT`
            );
        } else {
          let m = JSON.parse(message.toString());
          let [, , , deviceTyp] = topic.split("/");
          let { device_name } = m;
          let [, plantId, , deviceType, blockId, roomId, deviceId, timestamp] =
            topic.split("/");

          let parm = {
            plantId,
            blockId,
            roomId,
            sensor_time: m.timestamp,
            deviceId,
            deviceTyp,
            device_name,
            updatedBy: this.email,
          };
          if (m.active_power && m.active_power[0] == "true") this.updated = true;
          else if (m.reactive_power && m.reactive_power[0] == "true")
            this.updated = true;
          else if (m.power_factor && m.power_factor[0] == "true")
            this.updated = true;
          else if (m.device_type === "vcb" && m.status && m.status[0] == "true") {
            parm["status"] =
              this.vcbStatus[`${m.device_id}-${m.device_name}`] === 1 ? 0 : 1;
            this.insertDevicestatus(parm);
            await this.getVcbStatus();
            this.updated = true;
          } else if (
            m.device_type === "inverter" &&
            m.status &&
            m.status[0] == "true"
          ) {
            parm["status"] =
              this.apiDeviceStatus[`${m.device_type}-${m.device_id}`] === "1"
                ? 0
                : 1;
            this.insertDevicestatus(parm);
            await this.getDevicestatus();
            this.updated = true;
          } else this.error = true;
        }
      });

      this.client.on("error", function (error) {
        this.mqttStatus = {};
      });

      this.client.on("offline", function () {
        this.mqttStatus = {};
      });

      this.client.on("reconnect", function () {
        this.mqttStatus = {};
      });
      await this.getData();
      await this.getVCBData();
      await this.getVcbStatus();
      this.getDevicestatus();
    }
  },
};
</script>

<style>
#content-holder {
  box-shadow: 7px 7px 20px black;
}

.container.fluid {
  background-color: transparent;
}
</style>
<style lang="stylus" scoped>
.text-v-align {
  align-apiData: center;
  display: flex;
}
</style>